import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import { Translate } from "react-redux-i18n";
import { Button } from "@blueprintjs/core";
import "./WhiteMondayReadyToGift.scss";
import NewGiftDecorator from "../../containers/NewGiftDecorator/NewGiftDecorator";
const WhiteMondayReadyToGift = () => {
  return (
    <section className="white-monday-ready-to-gift cta-section">
        <div className="main-container">
          <div className="content-wrapper">
            <div className="main-cta-split">
              <div className="copy">
                <h1 className="hero-heading">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_ready_to_gift.heading" />
                </h1>
                <h2 className="bp3-heading light opacity90">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_ready_to_gift.subheading" />
                </h2>
              </div>
              <NewGiftDecorator>
                <Button
                  intent="primary"
                  className="cta primary-on-dark"
                  fill={true}>
                  <Translate value="whitemonday.landing_whitemonday.create_gift" />  
                </Button>
              </NewGiftDecorator>
            </div>
          </div>
        </div>
    </section>
  );
};

export default WhiteMondayReadyToGift;
